import React, { useContext, useState } from "react";
import { useMutation } from "@apollo/client";

import { AppForm } from "../../forms/AppForm";
import { AppInput } from "../../forms/AppInput";
import { AppSubmit } from "../../forms/AppSubmit";
import { Footer } from "../../components/Footer/footer";
import { GlobalContext } from "../../context/GlobalContext";
import { MUTATION_LOGGING } from "../../Graphql/mutations/MutationLogging";
import { useToastError } from "../../Hooks/useToastError";
import { useToastLoading } from "../../Hooks/useToastLoading";
import { useRedirectLogged } from "../../Hooks/useRedirectLogged";
import { Variables } from "../../styles/Variables";
import Header from "../../components/header";
import ModalForgetPassword from "../../Modals/ModalForgetPassword/ModalForgetPassword";
import ModalTermsDataPerson from "../../Modals/ModalDataPerson/ModalTermsDataPerson";

import {
  ContainerPrincipal,
  ContainerFormAndImage,
  ContainerForm,
  ContainerImage,
  Image,
  TextPrincipal,
  ContainerTexts,
  ContainerFooter,
  TextTermsPerson,
  TextForgetPassword,
  ContainerTransparent,
} from "../../styles/PageStyles/Login/LoginStyles";

const Login = () => {
  useRedirectLogged();
  // eslint-disable-next-line
  const TERMS_DATA_PERSON_ID = process.env.REACT_APP_TERMS_DATA_PERSON_ID;
  const [modalVisible, setModalVisible] = useState(false);
  const [modalVisibleForget, setModalVisibleForget] = useState(false);
  const { setToken, setRol, setUser } = useContext(GlobalContext);

  const [mutationLogin, { error, loading }] = useMutation(MUTATION_LOGGING, {
    onCompleted: (e) => {
      saveTokenOnSessionStorage(
        e.login.token,
        e.login.role,
        e.login.role === "ADMIN" ? e.login.user.nickname : e.login.user.userProfile.cities.name,
      );
      setToken(e.login.token);
      setRol(e.login.role);
      setUser(e.login.role === "ADMIN" ? e.login.user.nickname : e.login.user.userProfile.cities.name);
    },
    onError: (err) => console.error(err),
  });

  const saveTokenOnSessionStorage = (value, rol, user) => {
    window.sessionStorage.setItem("secret_key", value);
    window.localStorage.setItem("rol_user", rol);
    window.localStorage.setItem("name_user", user);
  };

  useToastLoading(loading);
  useToastError(error);

  const handleSubmit = (values) => {
    mutationLogin({
      variables: {
        email: values.user,
        password: values.password,
      },
    });
  };

  return (
    <ContainerPrincipal>
      <Header />
      <ContainerTransparent>
        <ContainerTexts>
          <TextPrincipal style={{ color: Variables.colorGrayClear }}>Admon portal</TextPrincipal>
          <TextPrincipal>
            <span style={{ color: Variables.colorOrange }}>www.integracion</span>
            <span style={{ color: Variables.colorBlue }}>migrante</span>
            <span style={{ color: Variables.colorRed }}>.com</span>
          </TextPrincipal>
        </ContainerTexts>
        <ContainerFormAndImage>
          <ContainerForm>
            <AppForm
              initialValues={{
                user: "",
                password: "",
              }}
              onSubmit={handleSubmit}
            >
              <AppInput
                label="Correo electrónico"
                name="user"
                placeholder="Email"
                styleLabel={{ fontWeight: 500 }}
                style={{ borderRadius: 10 }}
              />
              <AppInput
                label="Contraseña"
                name="password"
                placeholder="Contraseña"
                type="password"
                styleLabel={{ fontWeight: 500 }}
                style={{ borderRadius: 10 }}
              />
              <AppSubmit
                title="Ingresar"
                style={{ height: 30, borderRadius: 10, backgroundColor: Variables.colorOrange }}
              />
              <TextForgetPassword onClick={() => setModalVisibleForget(true)}>Olvide mi contraseña</TextForgetPassword>
              {/* <PrimaryNormal title="main" onClick={() => navigate(RoutesNames.main)} /> */}
            </AppForm>
          </ContainerForm>
          <ContainerImage>
            <Image src="/ImageLogin.png" />
          </ContainerImage>
        </ContainerFormAndImage>
      </ContainerTransparent>
      <ContainerFooter>
        <TextTermsPerson onClick={() => setModalVisible(true)}>TÉRMINOS Y CONDICIONES </TextTermsPerson>
      </ContainerFooter>
      <Footer styleText={{ color: Variables.colorBlackDark }} />
      <ModalTermsDataPerson
        modalVisible={modalVisible}
        setModalVisible={setModalVisible}
        idTermsAndConditions={TERMS_DATA_PERSON_ID}
      />
      <ModalForgetPassword modalVisible={modalVisibleForget} setModalVisible={setModalVisibleForget} />
    </ContainerPrincipal>
  );
};

export default Login;
